<div
  [formGroup]="parentForm"
  class="input input-text"
  [class.opaqueContainer]="isAutocompleteOpen"
  [class.input--filled]="isInputFilled(propertyName)"
  [class.input--error]="isInputInvalid(propertyName)"
>
  <ng-container *ngIf="!options?.isHidden && parentModel">
    <input
      type="text"
      [placeholder]="options?.placeholder"
      [tabindex]="tabindex"
      autocomplete="off"
      [readonly]="readonly"
      #input
      [formControlName]="propertyName"
      (blur)="onBlurInput()"
      [class.empty]="!input?.value"
    />
    <label
      *ngIf="options?.requiredPlaceholderLabelLeft"
      [style.left]="options?.requiredPlaceholderLabelLeft"
      class="required1"
      >*</label
    >
  </ng-container>
  <ng-container *ngIf="options?.isHidden && parentModel">
    <input
      type="text"
      [placeholder]="options?.placeholder"
      [tabindex]="tabindex"
      autocomplete="off"
      [readonly]="readonly"
      #input
      [class.empty]="!input?.value"
      (blur)="onBlurInput()"
    />
    <label
      *ngIf="options?.requiredPlaceholderLabelLeft"
      [style.left]="options?.requiredPlaceholderLabelLeft"
      class="required1"
      >*</label
    >
    <input
      type="hidden"
      [name]="propertyName"
      [id]="propertyName"
      [formControlName]="propertyName"
      [tabindex]="tabindex"
    />
  </ng-container>

  <div
    class="input input--select"
    *ngIf="!autocompleteLoading && isAutocompleteOpen"
    [class.active]="isAutocompleteOpen"
    (clickOutside)="closeMenu($event)"
    [clickOutsideEvents]="'click,touchstart'"
  >
    <div
      class="select__box {{ customSelectBoxScrollableClassName }}"
      [class.auto-width]="options?.autoWidth"
      [id]="propertyName"
    >
      <ng-container *ngFor="let item of autocompleteItems">
        <span class="select__options" (click)="onItemSelect(item)">
          <span [title]="item[(options?.textField)]">{{ getDescription(item[(options?.textField)]) }}</span>
        </span>
      </ng-container>
      <span *ngIf="autocompleteItems?.length === 0" class="select__options" (click)="onEmptyItemSelect()">
        <span>{{ options?.noItemsText }}</span>
      </span>
    </div>
  </div>

  <div *ngIf="autocompleteLoading" class="loader">
    <div class="ball1"></div>
    <div class="ball2"></div>
    <div class="ball3"></div>
  </div>

  <div *ngIf="allowClearance && isItemSelected" class="clear-input">
    <a href="" (click)="clearSelectedValue($event)">
      <svg-icon src="/assets/images/svg/icons/main-nav/close.svg"></svg-icon>
    </a>
  </div>
</div>
